// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientAccountPatientRegistrationDefaultResponse {
    static getAttributeTypeMap() {
        return PatientAccountPatientRegistrationDefaultResponse.attributeTypeMap;
    }
}
PatientAccountPatientRegistrationDefaultResponse.discriminator = undefined;
PatientAccountPatientRegistrationDefaultResponse.additionalProperties = false;
PatientAccountPatientRegistrationDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "IPatientRegistrationData"
    },
];
//# sourceMappingURL=patientAccountPatientRegistrationDefaultResponse.js.map